module.exports = __webpack_public_path__ + "img/yakult-stamp.aa1ffaf8.png";